import styled from 'styled-components';

import { AmendmentListItem } from '@xemplo/gp-types';
import { BodyXSmallMedium, BodyXSmallRegular, Colour } from '@xemplo/style-constants';
import { XemploTable } from '@xemplo/table';

export const Container = styled.div`
  width: 100%;
`;

export const Table = styled(XemploTable<AmendmentListItem>)`
  background: transparent;
  ${BodyXSmallRegular};
  color: ${Colour.Gray[500]};
  table {
    min-width: auto;
    thead {
      border: none;
      color: ${Colour.Gray[500]};
      ${BodyXSmallMedium};
    }

    tbody {
      ${BodyXSmallRegular};
    }
  }
`;
